module.exports = __webpack_public_path__ + "img/14.720381fc.jpg";